"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phishingImageWarning = (evaluatedImageUrl, evaluatedImageAlternativeText) => {
    const imageUrlHost = getHostName(evaluatedImageUrl);
    const alternativeTextHost = getHostName(evaluatedImageAlternativeText);
    if (alternativeTextHost === window.location.hostname) {
        return false;
    }
    return imageUrlHost !== alternativeTextHost;
};
exports.missingAltWarning = evaluatedImageAlternativeText => !evaluatedImageAlternativeText;
function getHostName(evaluatedImageUrl) {
    const imageUrlParser = document.createElement('a');
    imageUrlParser.href = evaluatedImageUrl;
    return imageUrlParser.hostname;
}
//# sourceMappingURL=calculate-warnings.js.map